import { makeAuthenticatedCall, makeCall } from '../commons/routes';

const RETENTION_REST_API_BASE_PATH = `${process.env.PUBLIC_URL}/api/retention/consultants`;

export const validateRetentionLink = (url, callback) =>
    makeCall(
        `${RETENTION_REST_API_BASE_PATH}/${url}/validate`,
        'POST',
        undefined,
        undefined,
        (statusDetails) => callback(statusDetails)
    );

export const authenticateRetentionLink = (url, payload, setAuth) =>
    makeCall(
        `${RETENTION_REST_API_BASE_PATH}/${url}/authenticate`,
        'POST',
        payload
    ).then((res) => {
        setAuth({
            isAuthenticated: true,
            token: `Bearer ${res.data.token}`,
        });
    });

export const reportIssueWithRetention = (url, payload) =>
    makeCall(`${RETENTION_REST_API_BASE_PATH}/${url}/issue`, 'POST', payload);

/** api calls beyond this point requires authentication */

export const sessionExpiryCheck = (url, authContext) =>
    makeAuthenticatedCall(
        `${RETENTION_REST_API_BASE_PATH}/${url}/sessionExpiryCheck`,
        'GET',
        undefined,
        authContext,
        null
    );

export function submitConsentResponse(url, payload, authContext) {
    return makeAuthenticatedCall(
        `${RETENTION_REST_API_BASE_PATH}/${url}/consentResponse`,
        'POST',
        payload,
        authContext
    );
}

export const logRetentionUserAgentInfo = (url, payload, authContext) =>
    makeAuthenticatedCall(
        `${RETENTION_REST_API_BASE_PATH}/${url}/userAgent`,
        'POST',
        payload,
        authContext
    );
